import type { SessionState } from "@/utils/sessionLifecycle"

/**
 * The one vocabulary for a session's state. Sentence case with a capital, as a
 * label rather than a sentence: it appears beside a dot, in a table cell and on
 * a card header, and any of those reading differently would be three states.
 */
export const SESSION_STATE_LABEL: Record<SessionState, string> = {
  draft: "Draft",
  live: "Live",
  paused: "Paused",
  complete: "Complete",
  expired: "Expired",
  removed: "Removed",
}

/**
 * The filter row above a list.
 *
 * Four buttons, not five: `paused` and `expired` are both kinds of unfinished
 * session and filtering them apart would leave two pills that are almost always
 * empty. `live` therefore matches paused too — see `matchesFilter`.
 */
export const STATE_FILTERS = ["all", "live", "complete", "draft"] as const

export type StateFilter = (typeof STATE_FILTERS)[number]

export const STATE_FILTER_LABEL: Record<StateFilter, string> = {
  all: "All",
  live: "Live",
  complete: "Complete",
  draft: "Draft",
}

export function matchesFilter(state: SessionState, filter: StateFilter): boolean {
  if (filter === "all") return true
  if (filter === "live") return state === "live" || state === "paused"
  if (filter === "draft") return state === "draft" || state === "expired"
  return state === "complete"
}
